// extracted by mini-css-extract-plugin
export default {"bold":"VerticalSummary_bold__QEnji","row":"VerticalSummary_row__KsPwZ","table":"VerticalSummary_table__m4jTU","min120":"VerticalSummary_min120__3F5bc"};